var _path, _path2, _g, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinHeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "422.8 54.9 535.5 563.6",
    enableBackground: "new 422.8 54.9 535.5 563.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FED477",
    stroke: "#FED477",
    strokeMiterlimit: 10,
    d: "M600.3,94.8c-13.4-23.5-38.8-39.3-67.8-39.3c-43.1,0-78,35-78,78 c0,22.2,9.3,42.2,24.2,56.5C508.7,146.8,551,113.4,600.3,94.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED477",
    stroke: "#FED477",
    strokeMiterlimit: 10,
    d: "M750.1,525.3c-14.5,5-36.3,8.1-60.6,8.1c-22.7,0-43.1-2.7-57.5-7.1 c-3.2,4-4.9,8.4-4.9,12.9c0,3.7,1.2,7.2,3.2,10.6c0.2,0.3,0.4,0.6,0.6,0.8c24.7,1.8,44.9,10.5,52.8,22.1c2.5,0.2,5.2,0.2,7.8,0.2 c1.2,0,2.4,0,3.6-0.1c5.6-9.6,19.7-17.4,37.8-21.2c5.7-1.2,11.8-2,18.3-2.3c0.6-0.1,1.3-0.2,1.8-0.3c1.8-3.2,2.9-6.4,2.9-9.9 C755.8,534.2,753.8,529.6,750.1,525.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FED477",
    stroke: "#FED477",
    strokeMiterlimit: 10,
    d: "M602,332c-18.4,0-34.3,10.5-42,25.8c-0.5,1.2-1.1,2.3-1.6,3.5 c-0.4,1-0.7,1.9-1.1,3c-1.5,2.4-3.3,5-5.5,7.7c-3.4,4.1-6.9,7.2-9.7,9.4c0.6-0.4-7.2,6.9-10.7,11.8c0,0,0,0,0,0.1c0,0,0,0-0.1,0 c-6.6,9.4-11,20.9-11,33.2c0,26.3,16.6,48.6,40.9,55.8l0,0c0-17.3,4-33.7,10.3-48.8c0-0.1,0.2-0.1,0.2-0.2c0,0,0.2,0,0.1-0.1l0,0 c1.9-4.3,4.4-9.1,6.8-13.2c8.9-15.8,20.9-29.4,35.3-40.1c9.7-7.2,20.5-13.1,32-17.3C639.4,344.7,622.1,332,602,332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED477",
    stroke: "#FED477",
    strokeMiterlimit: 10,
    d: "M531.3,393.3C531.3,393.2,531.3,393.2,531.3,393.3 C531.4,393.2,531.3,393.2,531.3,393.3z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED477",
    stroke: "#FED477",
    strokeMiterlimit: 10,
    d: "M845.5,391c-2.1-2.5-4.4-4.9-7-7c-0.7-0.6-1.5-1.2-2.2-1.8 c-0.4-0.3-1-0.6-1.5-1.1c-2.1-1.7-4.5-3.9-6.9-7c-2.2-3-4.2-5.4-5.3-8.5c-1.5-2.6-2.7-5.4-3.8-8.2c-8.1-14.1-23.4-23.5-40.7-23.5 c-19.6,0-36.4,11.9-43.5,28.9c11.7,4.4,22.7,10.6,32.6,18.2c14.2,10.9,26,24.7,34.6,40.6c1.6,2.9,3.1,5.8,4.3,8.9 c7,15.8,10.9,33.2,10.9,51.6c0,0.7,0,1.6,0,2.3c24.3-7,42.1-29.4,42.1-55.9C859.4,414.2,854.2,401.1,845.5,391z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FED477",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    d: "M575.5,538.7c-9.2-2.7-21.1-6.9-34.7-12.9 c-9.7-4.3-20.6-9.1-33.8-17.7c-8-5.2-22.1-15-36.3-30.1c-9.9-10.6-14.4-17.7-15.5-19.6c-5.1-8.4-7.7-15.5-10.3-22.7 c-0.7-2.2-5-14.1-7.7-28.8c-9.6-50.4-5.6-90.2-5.6-90.2c6.8-68.1,39.9-116.6,46.8-126.5c46-65.3,107.8-89.8,122.6-95.1 c80.6-29.7,150.2-9.2,169.5-2.9c14.9,5,78.2,27.4,126.7,92.2c0,0,54,72.2,53.1,159.4c-0.1,11.9-1.6,33.4-6.6,57.9 c-4.3,21.2-6.7,32.7-13.7,46.5c-13,25.6-32.2,40-48.6,52.3c-4.2,3.2-23.6,17.4-52.6,29.1c-9.5,3.8-17.8,6.4-24.1,8.2 c-4.7,10.1-14.6,28.5-34.4,44.6c-4,3.3-24.8,20-54.4,25.6c-11.3,2.2-21.9,2.4-26.4,2.3c-2.9,0-13.4-0.1-24.5-2.1 c-33.8-6.1-57.7-27.6-60.8-30.4C589,564.2,580.3,549,575.5,538.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED477",
    stroke: "#FED477",
    strokeMiterlimit: 10,
    d: "M902.8,190.9c14.9-14.2,24.2-34.3,24.2-56.5c0-43.1-35-78-78-78 c-29.1,0-54.3,15.9-67.8,39.3C830.5,114.4,872.8,147.8,902.8,190.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinHeads);
export default __webpack_public_path__ + "static/media/coin-heads.78b239c72eb0e8555e0af08c317a7072.svg";
export { ForwardRef as ReactComponent };